import { TagReads } from "../types/Tags";
import { Dispatch, SetStateAction, useRef } from "react";
import PlateGroup from "./PlateGroup";
import LoadingBar from "./LoadingBar";

export default function PlateList({ allPlates, displayPlates, setModalProps, loading, ourTime }: {
  allPlates: TagReads[];
  displayPlates: TagReads[];
  setModalProps: Dispatch<SetStateAction<TagReads | null>>;
  loading: boolean;
  ourTime: number;
}) {
  const listRef = useRef<HTMLDivElement>(null);

  // Group plates by dish name
  const groupedPlates = displayPlates.reduce((groups, plate) => {
    if (!plate.dishData) return groups;

    const dishName = plate.dishData.name;
    if (!groups[dishName]) {
      groups[dishName] = {
        dishData: plate.dishData,
        plates: []
      };
    }
    groups[dishName].plates.push(plate);
    return groups;
  }, {} as { [dishName: string]: { dishData: any, plates: TagReads[] } });

  // Convert to array and sort by count (most plates on belt first), then alphabetically
  const groupedArray = Object.values(groupedPlates).sort((a, b) => {
    // First sort by count (descending)
    const countDiff = b.plates.length - a.plates.length;
    if (countDiff !== 0) {
      return countDiff;
    }
    // If counts are equal, sort alphabetically by dish name
    return a.dishData.name.localeCompare(b.dishData.name);
  });

  return !loading ? (
    <>
      <div ref={listRef} style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        // overflowY: 'scroll',
      }}>
        {
          groupedArray.length > 0 ? (
            groupedArray.map((group) => {
              // For modal, we'll show the first plate of this group
              const firstPlate = group.plates[0];
              return (
                <PlateGroup
                  key={group.dishData.name}
                  dishData={group.dishData}
                  plates={group.plates}
                  ourTime={ourTime}
                  onClick={() => setModalProps(firstPlate)}
                />
              );
            })
          ) : (
            <div style={{ 
              display: 'flex', 
              flex: 1, 
              justifyContent: 'center', 
              alignItems: 'center', 
              fontSize: '18px',
              color: '#666',
              textAlign: 'center',
              padding: '20px'
            }}>
              Nothing available at the moment
            </div>
          )
        }
      </div>
    </>
  ) : (
    <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', fontSize: '20' }}>
      <LoadingBar />
    </div>
  );
}